import React, { useEffect } from 'react';
import classNames from 'classnames';
import {
  Box,
} from '@material-ui/core';

import { useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Helmet } from 'react-helmet';
import AppBar from '../../../components/appBar';

import styles from './ResultDetails.styles';
import { RequestResultDetailsArgs, ResultDetailsDispatchFunc, ResultDetailsInfo } from './types';
import SidePanel from '../../../components/sidePanel';
import NetworkState from '../../../core/types/network';
import { LoginInfo } from '../login/types';
import ResultDetailsHeader from './resultDetailsHeader';
import ResultDetailsBody from './resultDetailsBody';
import ResultDetailsFooter from './resultDetailsFooter';
import TestListPopup from './testListPopup';
import AttachListPopup from './attachListPopup';

const useStyles = makeStyles(styles);

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

type Props = {
  initialize: ResultDetailsDispatchFunc<unknown>;
  loginStatus?: LoginInfo;
  requestResultDetails: ResultDetailsDispatchFunc<RequestResultDetailsArgs>;
  resultDetails?: ResultDetailsInfo;
  networkStates: {
    resultDetailsRequest: NetworkState;
  };
};

const ResultDetails: React.FC<Props> = ({
  initialize,
  loginStatus,
  requestResultDetails,
  resultDetails,
  networkStates: {
    resultDetailsRequest,
  },
}: Props) => {
  const classes = useStyles();
  const query = useQuery();

  useEffect(() => {
    initialize();
  }, [initialize]);

  useEffect(() => {
    if (loginStatus !== undefined
      && !resultDetails
      && !resultDetailsRequest.isRequesting
      && !resultDetailsRequest.lastError?.message) {
      requestResultDetails({ id: query.get('id') || '' });
    }
  }, [loginStatus, query, requestResultDetails, resultDetails, resultDetailsRequest]);

  return (
    <Box className={classNames(classes.root)}>
      <Helmet>
        <title>
          {resultDetails
            ? `Lab No. ${resultDetails.requestInfo.labNumber}`
            : 'Loading...'}
        </title>
      </Helmet>
      <AppBar
        title={resultDetails
          ? `Lab No. ${resultDetails.requestInfo.labNumber}`
          : 'Loading...'}
      />
      <Box className={classes.detailsPanel}>
        <SidePanel />
        <Box className={classes.body}>
          <ResultDetailsHeader />
          <ResultDetailsBody />
          <ResultDetailsFooter />
        </Box>
      </Box>
      <AttachListPopup />
      <TestListPopup />
    </Box>
  );
};

export default ResultDetails;
